'use strict';

module.exports = ['$http',
    function ($http) {

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                model: '=',
                options: '=',
                details: '=',
                pbreadonly: '='
            },
            templateUrl: '/partial/app.directives.twitter_user',
            link: function (scope, element, attributes) {
                // scope.showMore = false;
                // scope.tweets = [];

                function error(error, value = null) {
                    if (scope.form && scope.form[scope.name]) { //make shure there is an form
                        if (value == null) {
                            return scope.form[scope.name].$error[error];
                        } else {
                            scope.form[scope.name].$setValidity(error, value);
                        }
                    }
                }

                scope.checkUsername = () => {
                    scope.loading = true;
                    let name = scope.model;
                    if (!name) {
                        scope.user = {};
                        // scope.tweets = {};
                        scope.loading = false;

                        if (error('noUsername')) {
                            error('noUsername', true);
                        }
                        if(error('noAccounts')) {
                            error('noAccounts', true);
                        }
                    } else {
                        $http.get('/social/twitter/userdata/' + name).then((response) => {
                            if (response.data.status == 404) {
                                error('noUsername', false);
                                scope.user = {};
                                scope.tweets = {};
                            } else if (response.data.status == 400 && response.data.message == 'no_accounts') {
                                error('noAccounts', false);
                            } else if (response.data.status == 200) {
                                scope.user = response.data.userData;
                                // scope.tweets = response.data.tweets;

                                if (error('noUsername')) {
                                    error('noUsername', true);
                                }
                                if(error('noAccounts')) {
                                    error('noAccounts', true);
                                }
                            }
                            scope.loading = false;
                        });
                    }
                };

                //init field when loaded
                scope.checkUsername();

                scope.$watch('model', (newVal, oldVal) => {
                    if(newVal !== undefined) {
                        scope.checkUsername();
                    }
                })
            }
        };
    }
];

